import React from "react";
import { Lock } from "lucide-react";

/**
 * ComingSoonCard — the "Automated Strategies" preview members see today.
 *
 * Lifted verbatim (copy and markup) out of the retired Signals tab so the
 * single "Automated Strategies" nav entry can show the teaser while
 * strategyAutomationTabEnabled is OFF — the default, and what every live
 * member gets — and the real tab once it is armed. Nothing here reads a flag,
 * touches the chain, or calls the backend: it is static copy.
 *
 * Compliance: educational software, not financial advice. No return, income,
 * or outcome claims. Non-custodial framing stays as written — do not soften.
 */
const ComingSoonCard = ({
  reason = "Access is gated while the product completes review.",
}) => (
  <div className="surface p-6 sm:p-8">
    <p className="eyebrow mb-2">Members tool · preview</p>
    <h2 className="headline text-2xl mb-3">
      Strategy Automation <span className="text-arc-gold">— coming soon</span>
    </h2>
    <div className="rounded-2xl border border-arc-line bg-white/[0.02] p-5">
      <div className="flex items-start gap-3">
        <Lock className="text-arc-gold flex-shrink-0 mt-0.5" size={18} />
        <div className="text-sm text-arc-muted leading-relaxed">
          <p className="mb-2">
            Automated, non-custodial trading from your own TradingView signal is
            being finalized. {reason}
          </p>
          <p>
            When it opens you'll connect your own wallet, keep custody of your
            collateral, set your own risk limits, and be able to revoke access at
            any time. This is educational software, not financial advice.
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default ComingSoonCard;
